// Concatenate multiple adaptive-mesh tiles into one draw call. The viewer
// used to create one deck.gl layer (and, with showEdges, a second GPU model)
// per leaf tile. Near dense coastlines that meant hundreds of WebGL pipelines
// / D3D11 rasterizer states and tripped HRESULT 0x887C0001 on Windows.
export function mergeMeshTiles(tiles) {
  let totalVerts = 0;
  let totalIndices = 0;
  for (const t of tiles) {
    totalVerts += t.nVerts;
    totalIndices += t.indices.length;
  }

  const positions3 = new Float32Array(totalVerts * 3);
  const scalarValues = new Float32Array(totalVerts);
  const wetMaskValues = new Float32Array(totalVerts);
  const triangleIndices = new Uint32Array(totalIndices);

  let vBase = 0;
  let iOff = 0;
  for (const t of tiles) {
    const n = t.nVerts;
    positions3.set(t.positions3.subarray(0, n * 3), vBase * 3);
    scalarValues.set(t.scalar.subarray(0, n), vBase);
    wetMaskValues.set(t.wetMask.subarray(0, n), vBase);

    const idx = t.indices;
    for (let i = 0; i < idx.length; i++) {
      triangleIndices[iOff + i] = idx[i] + vBase;
    }
    vBase += n;
    iOff += idx.length;
  }

  return {positions3, triangleIndices, scalarValues, wetMaskValues, nVerts: totalVerts};
}
